var exports = {
  "vW": "SlashCommandParamBar.module__inner___RDhRVl",
  "Qq": "SlashCommandParamBar.module__text___RDhRVl",
  "UU": "SlashCommandParamBar.module__name___RDhRVl",
  "h_": "SlashCommandParamBar.module__description___RDhRVl",
  "ku": "SlashCommandParamBar.module__requiredError___RDhRVl" + " " + "SlashCommandParamBar.module__description___RDhRVl",
  "ne": "SlashCommandParamBar.module__controls___RDhRVl",
  "x6": "SlashCommandParamBar.module__button___RDhRVl",
  "Kk": "SlashCommandParamBar.module__icon___RDhRVl",
};

module.exports = exports;
